import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { ThemeService } from '@aurrica-web/core-data';

/**
 * Shared card header for auth forms (logo + title).
 * Replaces the legacy hard-coded `#061831` banner.
 */
@Component({
  selector: 'lib-auth-form-header',
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div
      class="flex flex-col items-center gap-2 px-4 pt-5 pb-4 mb-6 border-b border-slate-200 dark:border-slate-700 bg-gradient-to-b from-slate-50 to-white dark:from-slate-900/80 dark:to-background-dark rounded-t-md"
    >
      <img [src]="logoSrc()" alt="Aurrica" class="h-9 w-auto object-contain" />
      <h1 class="text-base font-semibold text-slate-900 dark:text-white m-0">
        {{ title() }}
      </h1>
    </div>
  `,
})
export class AuthFormHeader {
  private readonly themeService = inject(ThemeService);

  /** Heading shown below the logo (e.g. "Sign In"). */
  title = input.required<string>();

  protected logoSrc(): string {
    return this.themeService.isDarkMode()
      ? './assets/auth/aurrica-logo.png'
      : './assets/auth/colored_logo.png';
  }
}
